module.exports = require('./flowRight');



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/lodash/fp/compose.js
// module id = 708
// module chunks = 0